export const PageDataState = {
    Searchs: {
        eec_nets_id: {
            type: 'text',
            id: 'eec_nets_id',
            label: '',
            value: '',
        },
        mission_name: {
            type: 'text',
            id: 'mission_name',
            label: 'ภารกิจ',
            value: '',
            placeholder: 'ภารกิจ',
        },
        mission_status: {
            type: 'select',
            id: 'mission_status',
            label: 'สถานะ',
            value: '',
        },
    },
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'primaryKey',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        eec_nets_id: {
            type: 'select',
            id: 'eec_nets_id',
            label: 'ศูนย์เครือข่าย',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        },        
        name: {
            type: 'textarea',
            rows: 3,
            id: 'name',
            label: 'ภารกิจ',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        description: {
            type: 'textarea',
            rows: '3',
            id: 'description',
            label: 'รายละเอียด',
            value: '',
            validator: {
                type: 'text',
                required: false,
                minLength: 5,
                maxLength: 4096
            },
            error: { status: null, msg: '' }
        }, 
        seq: {
            type: 'text',
            id: 'seq',
            label: 'ลำดับ',
            value: '',
            validator: {
                type: 'number',
                required: true,
                min: 1,
                max: 250
            },
            error: { status: null, msg: '' }
        },
        status: {
            type: 'select',
            id: 'status',
            label: 'สถานะ',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        }       
    },
    InputGroup: {}
}